import React, { useState } from 'react'
import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { LetterTab, LetterTabItem, LetterWrap } from 'src/styles/views/UserPage/letter'

import LetterHealth from '@/features/user/letter/components/LetterHealth'
import LetterLife from '@/features/user/letter/components/LetterLife'
import { COLOR } from '@/shared/constant/color'

const tabList = [
  { idx: 0, text: '헬스', path: 'health' },
  { idx: 1, text: '라이프', path: 'life' },
]
const UserLetterPage = () => {
  const { pathname } = useLocation()
  const [tabData, setTabData] = useState(pathname?.indexOf('health') >= 0 ? 0 : 1)
  const navigate = useNavigate()

  return (
    <LetterWrap>
      <LetterTab>
        {tabList?.map((option: { idx: number; text: string; path: string }) => (
          <LetterTabItem
            color={option.idx === tabData ? COLOR.black : COLOR.blueGray2}
            key={option.idx}
            onClick={() => {
              navigate(`/userPage/letter/${option?.path}`)
              setTabData(option.idx)
            }}
          >
            {option.text}
          </LetterTabItem>
        ))}
      </LetterTab>
      {pathname?.indexOf('health') >= 0 ? <LetterHealth /> : <LetterLife />}
    </LetterWrap>
  )
}
export default UserLetterPage
